export default function zoom(zoomLevel, Dispatcher, Store) {
  Dispatcher.dispatch({
    type: 'ZOOM_UPDATE',
    zoom: zoomLevel,
  });
}
